import React from "react";

const WHATSAPP_NUMBER = "9779842177777"; // +977-9842177777 (E.164 sans '+')
const DEFAULT_MESSAGE = "Hi AREL Nepal! I'd like to know more about your products.";

const WhatsAppButton = ({
  phone = WHATSAPP_NUMBER,
  message = DEFAULT_MESSAGE,
  testId = "whatsapp-float-btn",
}) => {
  const href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with AREL Nepal on WhatsApp"
      data-testid={testId}
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-5px_rgba(37,211,102,0.55)] ring-1 ring-black/5 transition-transform duration-300 ease-out hover:scale-110 hover:shadow-[0_16px_36px_-6px_rgba(37,211,102,0.7)] md:h-16 md:w-16"
    >
      <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366] opacity-20" />
      <svg viewBox="0 0 32 32" className="h-7 w-7 md:h-8 md:w-8" aria-hidden="true">
        <path
          fill="currentColor"
          d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.234 0-.234-.078-.79-.078-2.144 0-4.404-1.996-6.033-3.887C9.71 12.87 9.166 10.9 9.166 9.985c0-.586.117-.897.507-1.15.234-.155 1.088-.585 1.478-.585.117 0 .273.03.39.155.234.234 1.284 3.106 1.284 3.184 0 .195-.078.351-.234.507l-.507.507c-.156.156-.351.312-.351.507 0 .195.117.351.234.507.507.86 1.128 1.68 1.906 2.402.936.858 1.907 1.53 3.028 2.024.117.078.234.117.351.117.234 0 .43-.234.586-.39l1.362-1.596c.117-.117.312-.234.508-.234.117 0 3.028 1.478 3.223 1.634.117.078.156.234.156.351 0 .586-.352 1.325-.937 1.7-.586.352-1.245.585-1.907.585zM16 3.5C9.096 3.5 3.5 9.096 3.5 16c0 2.34.638 4.529 1.745 6.407L3.5 28.5l6.234-1.66A12.454 12.454 0 0016 28.5c6.904 0 12.5-5.596 12.5-12.5S22.904 3.5 16 3.5zm0 22.923c-2.156 0-4.175-.638-5.868-1.75l-.42-.234-3.67.976.99-3.577-.273-.42A10.454 10.454 0 015.577 16C5.577 10.234 10.234 5.577 16 5.577S26.423 10.234 26.423 16 21.766 26.423 16 26.423z"
        />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
